/**
 * Where "Back" in the settings menu goes: the last page the person was on
 * outside org settings. Kept in sessionStorage so a reload (or the round trip
 * through an OAuth callback that lands back in settings) still has it.
 */
const KEY = 'settings:returnTo';

/** A path this app can navigate to, and not one inside settings itself. */
function isUsable(path: unknown): path is string {
  return (
    typeof path === 'string' &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    path !== '/settings' &&
    !path.startsWith('/settings/') &&
    !path.startsWith('/settings?')
  );
}

export function readSettingsReturnTo(): string | null {
  try {
    const stored = window.sessionStorage.getItem(KEY);
    return isUsable(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function writeSettingsReturnTo(path: string): void {
  if (!isUsable(path)) return;
  try {
    window.sessionStorage.setItem(KEY, path);
  } catch {
    // Storage can be unavailable (private window); Back then falls back to home.
  }
}
